

































































import VueOptions from '@utils/VueOptions'
import PricingModel from '@services/PricingModel'

settings =
  name: "HostProductSamplingEditor"
  vue:
    props: ['space', 'spaceUpdated', 'event']
    data: ->
      form:
        min_quantity: null
        max_quantity: null
        agree_to_standard_pricing: null
        max_pallet_count: null
        placement: null
        can_serve_cold: null
        can_assemble_items: null

    created: ->
      @form[f] = @space[f] for f,v of @form
      @form.max_quantity ||= @event.product_sampling_handout_quantity

    computed:
      timeframe: ->
        return "" unless @event.local_start_day? and @event.local_end_day?
        s = "from #{@event.local_start_day} - #{@event.local_end_day}"
        s = "#{s} with #{@event.reach} estimated attendance" if parseInt(@event.reach) > 0
        s
    methods:
      imageForSpace: -> "#{process.env.VUE_APP_IMAGE_ENDPOINT}/spaces/#{@space.type}.png"

      hiSpaceUpdated: ->
        @space[f] = v for f, v of @form
        @event.product_sampling_handout_quantity = @form.max_quantity
        @spaceUpdated(@space)

export default VueOptions.vue settings
